<section class="mt-5 mb-5" *ngIf="currentBookletIndex != null && model != null && model.ExamBooklets != null && model.ExamBooklets.length > 0">
    <div class="row">
        <div class="col-md-12">
            <ul class="quiz-body-ul">
                <li class="li-text-left">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="quiz-head-background text-center">

                                <div class="row">
                                    <div class="col-md-2">

                                    </div>
                                    <div class="col-md-8">
                                        <h6 class="quiz-head">Kitapçık {{letters[currentBookletIndex]}} - Sınav Kağıdı</h6>
                                    </div>
                                    <div class="col-md-2 text-right">
                                        
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div class="col-md-12">

                            <ng-container *ngIf="model.ExamBooklets[this.currentBookletIndex].DocumentID != null">
                                <iframe style="min-height: -webkit-fill-available; width: 100%;" 
                                    [src]="model.ExamBooklets[this.currentBookletIndex].document.DocumentPath + '#toolbar=0' | asset | safeurl" 
                                    (loadstart)="bookletLoading = true;"
                                    (loadeddata)="bookletLoading = false; bookletLoaded = true;" 
                                    (error)="bookletLoading = false; bookletLoaded = false; bookletError = true;"
                                    scrolling="auto" type="application/pdf">
                                </iframe>
                                <div class="row">
                                    <div class="col-md-12 text-center" *ngIf="bookletLoading">
                                        <span>Sınav kitapçığınız yükleniyor..</span>
                                    </div>
                                    <div class="col-md-12 text-center" *ngIf="bookletError">
                                        <span>Sınav kitapçığınız yüklenirken hata meydana geldi.</span>
                                    </div>
                                </div>
                            </ng-container>
                            
                        </div>
                    </div>
                </li>
                <li class="li-text-right">
                    <div class="row" style="margin-left: unset !important;">
                        <div class="col-md-12 cevap-anahtari-positon">
                            <div class="quiz-all-background">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="quiz-head-background text-center">
                                            <h6 class="quiz-head">Kitapçık {{letters[currentBookletIndex]}} - Cevap Anahtarı</h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 text-center">
                                        <div class="body-background">
                                            <tabset>
                                                <tab *ngFor="let answerList of model.ExamBooklets[currentBookletIndex].ExamAnswerLists; let currentAnswerListIndex=index" [heading]="answerList.ExamAnswerListTitle">
                                                    <div class="row">
                                                        <div class="col-md-12 mt-4">
                                                            <ul class="quiz-ul" *ngFor="let answer of answerList.ExamAnswers; let i = index">
                                                                <li class="question-number" [class.two-digits]="i >= 9">
                                                                    <span class="question-number">{{ answer.QuestionID }}</span>
                                                                </li>
                                                                <li *ngFor="let item2 of answerSize; let k = index">
        
                                                                    <label class="label">
                                                                        <input name="q_{{currentBookletIndex}}_{{currentAnswerListIndex}}_{{answer.QuestionID}}" 
                                                                            class="label__checkbox" 
                                                                            type="radio" 
                                                                            [checked]="answer.QuestionAnswerID == k"
                                                                            (click)="answer.QuestionAnswerID = (answer.QuestionAnswerID == k) ? null : k"/>
                                                                        <span class="label__text">
                                                                            <span class="label__check">
                                                                                <span class="icon"> {{ letters[k] }} </span>  
                                                                            </span>
                                                                        </span>
                                                                    </label>
        
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <div class="col-md-12 mt-4 mb-2" *ngIf="isFinished == false">
                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <button *ngIf="isSaving == false" class="btn bgreen" [class.disabled]="isFinishing" [disabled]="isFinishing" (click)="saveExam()" style="width: 100%;">
                                                                        Cevapları Kaydet
                                                                    </button>
                                                                    <button *ngIf="isSaving == true" class="btn bgreen disabled" disabled style="width: 100%;">
                                                                        <i class="fa fa-spin fa-spinner"></i>
                                                                        Kaydediliyor
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12 mt-4 mb-2" *ngIf="isFinished == false">
                                                            <div class="row">
                                                                <div class="col-md-6 text-left">
                                                                    <span class="quiz-time">{{lastTime}}</span>
                                                                </div>
                                                                <div class="col-md-6 text-right">
                                                                    <button *ngIf="isFinishing == false" class="quiz-finish-button" [class.disabled]="isSaving" [disabled]="isSaving" (click)="finishExamConfirmed()">
                                                                        Sınavı Bitir
                                                                    </button>
                                                                    <button *ngIf="isFinishing == true" class="quiz-finish-button disabled" disabled>
                                                                        <i class="fa fa-spin fa-spinner"></i>
                                                                        Sınav Sonlandırılıyor
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12 mt-4 mb-2" *ngIf="isFinished">
                                                            <div class="row">
                                                                <div class="col-md-12 text-left">
                                                                    <span class="quiz-time">Sınavınız sona erdi</span>
                                                                </div>
                                                            </div>
                                                        </div>
        
                                                    </div>
                                                </tab>
                                            </tabset>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</section>
